import React from "react";
import PageHeader from "@/components/PageHeader";
import ItemsTable from "@/components/ItemsTable";
import { useDropdownOptions } from "@/hooks/useDropdownOptions";

export default function Jobs() {
  const { owners, priorities, jobStatuses, customerOpts, companyOpts } = useDropdownOptions();

  const columns = [
    { key: "job_name", label: "Job", type: "text", required: true, placeholder: "Job or order name" },
    { key: "company", label: "Company", type: "select", options: companyOpts, width: 190 },
    { key: "customer_id", label: "Customer", type: "select", options: customerOpts, width: 200 },
    { key: "owner", label: "Owner", type: "select", options: owners, width: 140 },
    { key: "status", label: "Current Status", type: "select", options: jobStatuses, width: 220 },
    { key: "priority", label: "Priority", type: "select", options: priorities, width: 130 },
    { key: "order_received_date", label: "Received", type: "date", width: 150 },
    { key: "due_date", label: "Due", type: "date", width: 150 },
    { key: "notes", label: "Notes", type: "text" },
    { key: "completed", label: "Done", type: "checkbox", width: 80 },
  ];

  return (
    <div className="max-w-[1600px] mx-auto px-8 py-10">
      <PageHeader
        eyebrow="Jobs & Orders"
        title="Production Line"
        description="Track every job from order received through pressing, delivery, and invoicing."
      />
      <ItemsTable
        endpoint="jobs"
        columns={columns}
        defaultItem={{ job_name: "", customer_id: "", company: "JTD of CHS", status: "needs to be quoted", priority: "Normal", owner: "", completed: false, notes: "" }}
        testIdPrefix="jobs"
        emptyLabel="No jobs yet — add your first one above."
      />
    </div>
  );
}
